import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    imports: [CommonModule],
    templateUrl: './pagination.component.html',
    standalone: true,
    styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() currentPage = 0;
  @Input() totalPages = 0;
  @Output() pageChange = new EventEmitter<number>();

  get displayedPages(): number[] {
    const pages: number[] = [];
    if (this.totalPages <= 5) {
      for (let i = 0; i < this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(0, 1);
      if (this.currentPage > 2) {
        pages.push(this.currentPage);
      }
      pages.push(this.totalPages - 2, this.totalPages - 1);
    }
    return [...new Set(pages)];
  }

  changePage(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.pageChange.emit(page);
    }
  }
}
